/**
 * LOCKED analytics event catalog (docs/_spec-backbone.md §5, AEV-* in
 * docs/requirements/10-analytics.md). Never invent, rename, or re-slug a
 * name here — `track()` is restricted to this union so an unlocked name
 * fails type-check (FR-ANALYTICS-001).
 */
export const ANALYTICS_EVENT_NAMES = [
  "liff_opened",
  "venue_session_viewed",
  "age_gate_confirmed",
  "consent_accepted",
  "line_profile_prefilled",
  "table_joined",
  "privacy_mode_selected",
  "menu_viewed",
  "item_added_to_cart",
  "order_submitted",
  "order_accepted",
  "order_served",
  "around_viewed",
  "table_profile_viewed",
  "gift_started",
  "gift_sent",
  "gift_accepted",
  "gift_rejected",
  "gift_fulfilled",
  "contact_request_sent",
  "contact_request_accepted",
  "contact_request_rejected",
  "report_submitted",
  "block_user",
  "game_joined",
  "session_left",
  "screen_post_submitted",
  "screen_post_paid",
  "screen_post_approved",
  "screen_post_displayed",
  "screen_post_rejected",
] as const;

export type AnalyticsEventName = (typeof ANALYTICS_EVENT_NAMES)[number];

/**
 * The small pre-auth/pre-consent essential set (docs/requirements/10-analytics.md
 * §10.1 edge cases; mirrors the backend's `PRE_AUTH_EVENT_NAMES`). ONLY these
 * may be emitted before consent resolves and/or without an authenticated
 * principal — everything else buffers until consent is accepted, and is
 * dropped if declined (FR-ANALYTICS-003).
 */
export const PRE_AUTH_ANALYTICS_EVENT_NAMES: readonly AnalyticsEventName[] = [
  "liff_opened",
  "venue_session_viewed",
  "age_gate_confirmed",
  "consent_accepted",
];

export function isPreAuthAnalyticsEvent(name: AnalyticsEventName): boolean {
  return PRE_AUTH_ANALYTICS_EVENT_NAMES.includes(name);
}
